import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import Logo from "@/components/Logo";
import Seo from "@/components/Seo";
import { api, formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("ic_admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F5F8FC] px-5">
      <Seo title="Admin Login | Incremental Consulting" description="Administrator sign-in for Incremental Consulting." />
      <div className="w-full max-w-sm rounded-2xl border border-[#0B1F3A]/10 bg-white p-8 shadow-[0_24px_60px_-30px_rgba(11,31,58,0.35)]" data-testid="admin-login-card">
        <Logo />
        <h1 className="mt-8 font-display text-xl font-bold text-[#0B1F3A]">Admin sign-in</h1>
        <p className="mt-1 text-sm text-[#667085]">Manage enquiries and job postings.</p>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="admin-login-form">
          <div>
            <label htmlFor="al-email" className="mb-1.5 block text-[13px] font-semibold text-[#172033]">Email</label>
            <input id="al-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              className="w-full rounded-lg border border-[#0B1F3A]/15 px-4 py-3 text-sm outline-none focus:border-[#A87B1F] focus:ring-2 focus:ring-[#A87B1F]/15" />
          </div>
          <div>
            <label htmlFor="al-password" className="mb-1.5 block text-[13px] font-semibold text-[#172033]">Password</label>
            <input id="al-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              className="w-full rounded-lg border border-[#0B1F3A]/15 px-4 py-3 text-sm outline-none focus:border-[#A87B1F] focus:ring-2 focus:ring-[#A87B1F]/15" />
          </div>
          {error && <p className="text-sm text-red-500" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={busy} data-testid="admin-login-submit"
            className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#0B1F3A] px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#A87B1F] disabled:opacity-60">
            {busy ? <Loader2 size={16} className="animate-spin" /> : <Lock size={15} />}
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
